import React from "react";
import { DecisionTreeViewer, GuidedAnalysisViewer } from "../../modules/assist/components";
import { demoDecisionTree, demoGuidedAnalysis } from "../../modules/assist/models";

// Assist · Analyse : arbre de décision + analyse guidée.
export default function AssistAnalyse() {
  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Assist · Analyse</h1>
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
          Analyser des situations, des choix ou des relations avec un arbre de décision et un guide pas à pas.
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Arbre de décision</h2>
        <DecisionTreeViewer tree={demoDecisionTree} />
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Analyse guidée pas à pas</h2>
        <GuidedAnalysisViewer flow={demoGuidedAnalysis} />
      </section>
    </div>
  );
}
